import React from "react";

//header
import Header from "../../components/partials/dashboard/HeaderStyle/header";

//sidebar
import RightSidebar from "../../components/partials/dashboard/SidebarStyle/rightsidebar";

//sidebar
import Sidebar from "../../components/partials/dashboard/SidebarStyle/sidebar";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";

//settingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";
import { Outlet } from "react-router-dom";

const Default = () => {
  return (
    <>
      <Sidebar />
      {/* <HeaderOne/> */}
      <div className="main-content">
        <div
          className="position-relative"
          style={{ marginBottom: "100px", width: "100%" }}
        >
          <Header />
          {/* <div id="content-page" className="content-inner"> */}
          {/* <DefaultRouter/> */}
          <Outlet />
          {/* </div> */}
        </div>
      </div>
      {/* <RightSidebar /> */}
      <div className="fixed-bottom">
        <Footer />
      </div>
      <SettingOffCanvas />

      {/* Keep every page's content wrapper lined up with the slim
          sidebar (220px expanded / 64px collapsed — see sidebar.jsx).
          .sidebar and .main-content are siblings in the DOM here, so
          this reacts automatically to the sidebar-mini toggle without
          any JS. Remove this block if you change the sidebar width. */}
      <style>{`
        .sidebar-slim ~ .main-content {
          margin-left: 220px !important;
          transition: margin-left 0.2s ease;
        }
        .sidebar-slim.sidebar-mini ~ .main-content {
          margin-left: 64px !important;
        }
        @media (max-width: 1024px) {
          .sidebar-slim ~ .main-content,
          .sidebar-slim.sidebar-mini ~ .main-content {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </>
  );
};

export default Default;
